<div class="brain-title">
  <div class="title">좌우뇌 균형도 검사</div>
  <div class="date">{{date}}</div>
</div>
<div class="brain-wrap">
  <div class="brain-graph-left">
    <div class="txt">좌뇌</div></div><div class="brain-graph">
    <img class="img-graph" src="assets/images/bbreport_brain_bg.png">
    <img class="img-graph" src="assets/images/bbreport_brain_fill_01.png" [graph-percent]="brainRightPercent">
    <img class="img-graph" src="assets/images/bbreport_brain_fill_02.png" [graph-percent]="brainLeftPercent">
    <img class="img-graph" src="assets/images/bbreport_brain.png">
    <div class="desc-left">{{brainLeftPercent}}%</div>
    <div class="desc-right">{{brainRightPercent}}%</div>
  </div><div class="brain-graph-right"><div class="txt">우뇌</div></div>
</div>
